import React, { useState } from "react";

const ImageUploader = (props) => {
    const {setImageUrls} = props;
  const [mainImage, setMainImage] = useState(null);
  const [extraImages, setExtraImages] = useState([]);
  const [uploadedUrls, setUploadedUrls] = useState(null);
  const [status, setStatus] = useState("");

  const phpPath = "https://eleven.fit/php"; // adjust for localhost if needed

  const handleUpload = async () => {
    if (!mainImage && extraImages.length === 0) {
      alert("Please select at least one image");
      return;
    }

    const formData = new FormData();
    if (mainImage) formData.append("mainImage", mainImage);
    extraImages.forEach((img) => formData.append("extraImages[]", img));

    setStatus("Uploading...");

    try {
      const res = await fetch(`${phpPath}/img_upload.php`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      console.log("Upload response:", data);

      if (data.success) {
        setUploadedUrls(data);
        setImageUrls(data);
        setStatus("✅ Upload successful!");
      } else {
        setStatus("❌ Upload failed");
      }
    } catch (err) {
      console.error(err);
      setStatus("❌ Error uploading images");
    }
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h2>🖼️ Image Uploader</h2>

      <label>Main Image:</label>
      <input
        type="file"
        onChange={(e) => setMainImage(e.target.files[0])}
        accept="image/*"
      />

      <br />
      <label>Extra Images:</label>
      <input
        type="file"
        multiple
        onChange={(e) => setExtraImages(Array.from(e.target.files))}
        accept="image/*"
      />

      <br />
      <button onClick={handleUpload}>Upload</button>
      <p>{status}</p>

      {uploadedUrls && (
        <div>
          <h4>Uploaded URLs:</h4>
          <p><strong>Main:</strong> {uploadedUrls.mainImageUrl}</p>
          <strong>Extras:</strong>
          <ul>
            {uploadedUrls.extraImageUrls.map((url, i) => (
              <li key={i}>{url}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
